import { useEffect } from 'react'
import TextEditor from '../../../../TextEditor'
import { descriptionValueHtml } from './descriptionValue'
import SubmitModalButton from 'components/Custom/SubmitModalButton'
import CancelModalButton from 'components/Custom/CancelModalButton'
function EditDescription(props) {
  useEffect(() => {
    if (props.prevChecklistDescription) {
      props.prevChecklistDescription(props.checklist.description)
    }
  }, [props.checklist.description, props.prevChecklistDescription])

  const onChangeDescription = (value, name) => {
    props.onChangeDescription('description', value)
  }

  const language = props.language || {}

  return (
    <div className='container-fluid'>
      <div className='row larger-spacing'>
        <div className='col-12 px-0'>
          <TextEditor
            onChangeText={onChangeDescription}
            textContent={
              props.checklist.description &&
              Object.keys(props.checklist.description).length
                ? props.checklist.description
                : descriptionValueHtml
            }
            changeProperty='description'
            setOptions={{
              buttonList: [
                ['bold', 'underline', 'italic', 'formatBlock'],
                ['table', 'image', 'link'],
              ],
            }}
          />
        </div>
      </div>
      <div className='row  mt-4'>
        <div className='col-12 px-0'>
          <SubmitModalButton
            text={language && language.general ? language.general.save : null}
            customFn={props.saveDescription}
          />

          <CancelModalButton
            text={language && language.general ? language.general.cancel : null}
            customFn={props.cancelSection}
          />
        </div>
      </div>
    </div>
  )
}

export default EditDescription
